import {
  Reference,
  ReferenceFromJSON,
  ReferenceToJSON,
  ReferenceUpdateDatabaseRequestToJSON
} from '@/api/models'
import {
  ReferenceListItem,
  ReferenceListItemFromJSON
} from '@/api/models/reference/ReferenceListItem'
import { ReferenceSearchConditionsItem } from '@/store/ReferenceListStore'
import { HTTPBody } from '@/api'
import * as runtime from '../runtime'

export interface GetReferenceRequest {
  id: number
}

export interface GetReferencesRequest {
  searchConditions: ReferenceSearchConditionsItem
}

export interface CreateReferenceRequest {
  reference: Reference
}

export interface UpdateReferenceRequest {
  reference: Reference
}

export interface DownloadReferenceCsvRequest {
  ids: number[]
}

export interface UpdateReferenceDatabaseRequest {
  ids: number[]
}

export interface DeleteReferenceRequest {
  id: number
}

/**
 * no description
 */
export class ReferenceApi extends runtime.BaseAPI {
  /**
   * 入力条件により、レファレンス一覧を取得する
   * レファレンス一覧取得
   */
  async getReferences(
    request: GetReferencesRequest
  ): Promise<ReferenceListItem[]> {
    const queryParameters: runtime.HTTPQuery = {}

    if (request.searchConditions.searchDateType !== null) {
      queryParameters.search_date_type = request.searchConditions.searchDateType
    }

    if (request.searchConditions.startDate !== null) {
      queryParameters.start_date = request.searchConditions.startDate
    }

    if (request.searchConditions.endDate !== null) {
      queryParameters.end_date = request.searchConditions.endDate
    }

    if (request.searchConditions.contentTypeText !== null) {
      queryParameters.content_type_text =
        request.searchConditions.contentTypeText
    }

    if (request.searchConditions.freeKeyword !== null) {
      queryParameters.free_keyword = request.searchConditions.freeKeyword
    }

    const response = await this.requestGet(`/references`, queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(ReferenceListItemFromJSON)
    ).value()
  }

  async getReferenceById(request: GetReferenceRequest): Promise<Reference> {
    const response = await this.requestGet(`/references/${request.id}`)

    return new runtime.JSONApiResponse(
      response,
      jsonValue => (jsonValue = ReferenceFromJSON(jsonValue))
    ).value()
  }

  async create(requestBody: CreateReferenceRequest): Promise<Reference> {
    const bodyParameters: runtime.HTTPBody = ReferenceToJSON(
      requestBody.reference
    )

    const response = await this.requestPost('/references', bodyParameters)

    return new runtime.JSONApiResponse(
      response,
      jsonValue => (jsonValue = ReferenceFromJSON(jsonValue))
    ).value()
  }

  /**
   * レファレンスIDによりレファレンスを更新する
   * レファレンス更新
   */
  async update(requestBody: UpdateReferenceRequest): Promise<Reference> {
    const bodyParameters: HTTPBody = ReferenceToJSON(requestBody.reference)

    const response = await this.requestPut(
      `/references/${requestBody.reference.id}`,
      bodyParameters
    )

    return new runtime.JSONApiResponse(
      response,
      jsonValue => (jsonValue = ReferenceFromJSON(jsonValue))
    ).value()
  }

  /**
   * CSVファイルを出力したURLを取得する
   * URL取得
   */
  async downloadCsv(requestBody: DownloadReferenceCsvRequest): Promise<string> {
    const response = await this.requestPost('/references.csv', requestBody)

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.url
    ).value()
  }

  /**
   * レファレンスIDにより協同データベース登録可否を更新する
   * 協同データベース登録可否更新
   */
  async updateDatabase(
    requestBody: UpdateReferenceDatabaseRequest
  ): Promise<void> {
    const bodyParameters: HTTPBody = ReferenceUpdateDatabaseRequestToJSON(
      requestBody
    )

    const response = await this.requestPut(
      `/references/database/register`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response).value()
  }

  /**
   * レファレンスIDによりレファレンスを削除する
   * レファレンス削除
   */
  async delete(request: DeleteReferenceRequest): Promise<void> {
    const response = await this.requestDelete(`/reference/${request.id}`)

    return new runtime.VoidApiResponse(response).value()
  }
}
